import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Api from '@services/works.service';
import { textareaTextToArrayWithParams } from '@utils/utils';

export const fetch_works = createAsyncThunk(
  'works/fetch_works',
  async (_, thunkAPI) => {
    try {
      const response = await Api.get_works();
      return response.data;
    } catch {
      return [];
    }
  },
);

export const fetch_work = createAsyncThunk(
  'works/fetch_work',
  async (slug, thunkAPI) => {
    try {
      const response = await Api.get_work(slug);
      return response.data;
    } catch {
      return [];
    }
  },
);
export const worksSlice = createSlice({
  name: 'works',
  initialState: {
    works: [],
    work: {},
    is_fetching_works: false,
    is_fetching_work: false,
  },
  reducers: {
    setWorks: (state, action) => {
      state.works = action.payload;
    },
    setWork: (state, action) => {
      state.work = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetch_works.fulfilled, (state, action) => {
        let fetchedData = action.payload;
        if (Array.isArray(action.payload)) {
          fetchedData = fetchedData.map((item) => {
            return {
              id: item.id,
              slug: item.slug,
              ...item.acf,
              videos: textareaTextToArrayWithParams(item.acf.videos),
            };
          });
        }

        const childrenMap = {};
        fetchedData.forEach((item) => {
          if (item.has_children) {
            childrenMap[item.id] = item.child_item;
          }
        });

        fetchedData.forEach((item) => {
          if (childrenMap[item.id]) {
            item.items = fetchedData.filter((child) =>
              childrenMap[item.id].includes(child.id),
            );
          }
        });

        fetchedData = fetchedData.filter(
          (item) => !Object.values(childrenMap).flat().includes(item.id),
        );
        state.works = fetchedData;
        state.is_fetching_works = false;
      })
      .addCase(fetch_works.pending, (state) => {
        state.is_fetching_works = true;
      })
      .addCase(fetch_works.rejected, (state) => {
        state.is_fetching_works = false;
      })
      .addCase(fetch_work.fulfilled, (state, action) => {
        let fetchedData = action.payload;
        if (Array.isArray(action.payload)) {
          fetchedData = fetchedData.map((item) => {
            return {
              id: item.id,
              slug: item.slug,
              ...item.acf,
              videos: textareaTextToArrayWithParams(item.acf.videos),
            };
          });
        }

        if (fetchedData.length === 0) {
          state.work = {};
          state.is_fetching_work = false;
          return;
        }

        state.work = fetchedData[0];
        state.is_fetching_work = true;
      })
      .addCase(fetch_work.pending, (state) => {
        state.is_fetching_work = true;
      })
      .addCase(fetch_work.rejected, (state) => {
        state.is_fetching_work = false;
      });
  },
});

export const { setWorks } = worksSlice.actions;

export default worksSlice.reducer;
